import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { addZone, editZone } from "../../../services/MasterApiServices";
import toast from "react-hot-toast";
import { ZoneClass } from "../../../core/json/ZoneClass";
import { useSelector } from "react-redux";
import { guid } from "rsuite/esm/internals/utils";

const ZoneModal = ({ mode, data, handleClose, handleRefresh }) => {
  const { register, handleSubmit, setValue, reset } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  // Get user from redux
  const { userId } = useSelector((state) => state.userauth);
  const { branch } = useSelector((state) => state.branchlist);

  function resetmodal() {
    if (mode === "edit" && data) {
      setValue("name", data.name);
        setValue("otherLanguageName", data.otherLanguageName);
      // Populate form with data for editing
    } else {
      reset();
    }
  }

  useEffect(() => {
    resetmodal();
  }, [data, mode, setValue]);

  // Handle form submission for adding or editing a zone
  const handleFormSubmit = async (formData) => {
    const objzone = new ZoneClass();
    objzone.name = formData.name;
    objzone.otherLanguageName = formData.otherLanguageName;
    objzone.branch = branch;
objzone.branchID = branch?.guid || null; // Ensure branchID is se
    objzone.updatedUser = `${userId?.id}`; //"{9b57619d-63c8-4e27-9a59-639f0c80e4a1}";
    objzone.createdUser = `${userId?.id}`; //"{9b57619d-63c8-4e27-9a59-639f0c80e4a1}";
    if (mode === "edit") {
      objzone.guid = data.guid;
      objzone.id = data.id;
    }

    try {
      const response =
        mode === "edit" ? await editZone(objzone) : await addZone(objzone);

      if (response.data==true) {
        toast.success("Success");
        handleRefresh(); // Refresh the list
        handleClose(); // Close the modal
      }else if(response.data==false){
        toast.error("false")
       }
    } catch (error) {
      toast.error(error?.response?.data?.Message || "something went wrong");
      console.error(
        "Error handling zone:",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  return (
    <div>
      <div
        className="modal fade show"
        style={{ display: "block" }}
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>{mode === "edit" ? "Edit Zone" : "Add Zone"}</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    aria-label="Close"
                    onClick={handleClose}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <form onSubmit={handleSubmit(handleFormSubmit)}>
                    <div className="row">
                      <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="input-blocks">
                          <label>
                            Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="name"
                            {...register("name")}
                            required
                          />
                        </div>
                      </div>
                         <div className="col-md-6 col-sm-12">
                        <div className="input-blocks">
                          <label>
                            Other Language Name
                          </label>
                          <input
                            type="text"
                            placeholder="Other Language Name"
                            {...register("otherLanguageName")}
                          
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-12">
                      <div className="modal-footer-btn">
                        <button
                          type="button"
                          className="btn btn-cancel me-2"
                          onClick={() => resetmodal()}
                        >
                          Reset
                        </button>
                        <button type="submit" className="btn btn-submit">
                          {mode === "edit" ? "Save Changes" : "Save"}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ZoneModal;
